import type {
  LC_ListMarksReportItem,
  LC_ListMarksReportOut,
  MarkReport,
  MarksReportPage,
} from '../types/marksReport.types';
import { normalizeMarkPhoto } from './markPhoto.mapper';


export function mapMarkReport(item: LC_ListMarksReportItem): MarkReport {
  const { photoUrl, photoBase64 } = normalizeMarkPhoto(item.photo);
  return {
    id: item.id,
    rut: item.employeeTaxIdentificationNumber,
    fullName: item.fullName,
    companyName: item.companyName,
    contractNumber: item.contractNumber,
    positionName: item.positionName,
    markType: item.markType,
    eventName: item.eventName,
    workdayDate: item.workdayDate,
    markTime: item.markTime,
    locationName: item.locationName,
    markDate: item.markDate ?? null,
    note: item.note ?? null,
    observation: item.observation ?? null,
    latitude: item.latitude ?? null,
    longitude: item.longitude ?? null,
    photoUrl,
    photoBase64,
    deviceName: item.deviceName ?? null,
    mapUrl: item.mapUrl ?? null,
    eventId: item.eventId,
    hasPendingAdjustment: item.hasPendingAdjustment,
  };
}

export function mapMarksReportPage(out: LC_ListMarksReportOut): MarksReportPage {
  const pagination = out.pagination;
  return {
    items: (out.items ?? []).map(mapMarkReport),
    pagination: {
      currentPage: pagination?.currentPage ?? 1,
      pageSize: pagination?.pageSize ?? 0,
      totalRecords: pagination?.totalRecords ?? 0,
      totalPages: pagination?.totalPages ?? 0,
      hasPreviousPage: pagination?.hasPreviousPage ?? false,
      hasNextPage: pagination?.hasNextPage ?? false,
    },
  };
}
